<section ngForm="vbRtmpDetailsForm" #vbRtmpDetailsForm="ngForm">
	<ng-container *ngIf="(rtmpContext$ | async) as rtmpContext">
		<ng-container *ngIf="rtmpContext">
			@if (webcastType !== WebcastVideoSource.SRT) {
				<div class="form-group row">
					<label id="ewRtmpSourceProtocol" class="control-label col-sm-3">{{ 'Protocol' | translate }}</label>
					<div class="col-sm-9">
						<div class="row">
							<div class="col-md-6 col-sm-9">
								<div vbUiRadioBtnGroup aria-labelledby="ewRtmpSourceProtocol">
									<button type="button" class="util-uppercase btn btn-admin btn-white" name="rtmpProtocol" [(ngModel)]="rtmpContext.isSecure" [vbUiRadioBtn]="false" [notThemed]="!themed" [activeClass]="themed ? '' : 'active'" (ngModelChange)="onProtocolChange(rtmpContext.isSecure)">
										{{ 'Rtmp' | translate }}
									</button>
									<button type="button" name="rtmpsProtocol" class="util-uppercase btn btn-admin btn-white" [(ngModel)]="rtmpContext.isSecure" [vbUiRadioBtn]="true" [notThemed]="!themed" [activeClass]="themed ? '' : 'active'" (ngModelChange)="onProtocolChange(rtmpContext.isSecure)">
										{{ 'Rtmps' | translate }}
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			}
			<div class="form-group row">
				<label class="control-label col-sm-3">{{ 'Event_Webcast_Rtmp_PushUrl' | translate }}
					<vb-ui-tooltip [iconName]="'circle_question_mark'" [placement]="'right'" [text]="'Event_Webcast_Rtmp_Url_Info' | translate">
					</vb-ui-tooltip>
				</label>
				<div class="col-sm-9">
					<div class="row">
						<div class="col-md-6 col-sm-9">
							{{ rtmpContext.pushUrl }}
							<button type="button" class="margin-left-10" [attr.aria-label]="'Event_Webcast_Rtmp_PushUrlCopy' | translate" [title]="'Event_Webcast_Rtmp_PushUrlCopy' | translate" ngxClipboard [cbContent]="rtmpContext.pushUrl" vbBtnWhite>
								<span class="glyphicons file_import"></span>
							</button>
						</div>
						<div *ngIf="errors?.RtmpListenerUrlConflict" class="margin-left-16 col-md-6 col-sm-9 px-0" role="alert" vbUiErrorMessage>
							{{ 'Event_Webcast_Rtmp_PushUrlConflictError' | translate }}
						</div>
					</div>
				</div>
			</div>
			@if (webcastType !== WebcastVideoSource.SRT) {
				<div class="form-group row">
					<label class="control-label col-sm-3">{{ 'StreamKey_Primary' | translate }}</label>
					<div class="col-sm-9">
						<div class="row">
							<div class="col-md-6 col-sm-9">
								{{ rtmpContext.streamKey }}
								<button type="button" class="margin-left-10" [attr.aria-label]="'Event_Webcast_Rtmp_StreamCopy' | translate" [title]="'Event_Webcast_Rtmp_StreamCopy' | translate" ngxClipboard [cbContent]="rtmpContext.streamKey" vbBtnWhite>
									<span class="glyphicons file_import"></span>
								</button>
							</div>
						</div>
					</div>
				</div>
			}
			<div class="form-group row">
				<label class="control-label col-sm-3"></label>
				<div class="col-sm-9">
					<div class="row">
						<div class="col-sm-9 col-md-6">
							<button type="button" (click)="generateNewSettings(rtmpContext.isSecure, true)" vbBtnWhite>
								@if (webcastType !== WebcastVideoSource.SRT) {
									{{ 'Event_Webcast_Rtmp_RegenerateUrlAndKey' | translate }}
								}
								@else {
									{{ 'Event_Webcast_Srt_RegenerateUrl' | translate }}
								}
							</button>
						</div>
					</div>
				</div>
			</div>
			@if (features.enableSecondaryRtmp) {
				<div class="form-group row">
					<label id="ewRtmpSourceBackupStream" class="control-label col-sm-3">{{ 'Event_Webcast_Rtmp_Backup_Stream' | translate }}
						<vb-ui-tooltip [iconName]="'circle_question_mark'" [placement]="'right'" [text]="(webcastType === WebcastVideoSource.SRT ? 'Event_Webcast_Srt_Backup_Stream_Tooltip' : 'Event_Webcast_Rtmp_Backup_Stream_Tooltip') | translate">
						</vb-ui-tooltip>
					</label>
					<div class="col-sm-9">
						<div class="row">
							<div class="col-md-6 col-sm-9">
								<div vbUiRadioBtnGroup aria-labelledby="ewRtmpSourceBackupStream">
									<button type="button" class="btn btn-admin btn-white" name="rtmpBackupStreamEnable" [(ngModel)]="rtmpContext.backupStreamEnabled" [vbUiRadioBtn]="true" [notThemed]="!themed" [activeClass]="themed ? '' : 'active'" (ngModelChange)="onBackupStreamChange(rtmpContext.backupStreamEnabled, rtmpContext.isSecure)">
										{{ 'UI_Enabled' | translate }}
									</button>
									<button type="button" class="btn btn-admin btn-white" name="rtmpBackupStreamDisable" [(ngModel)]="rtmpContext.backupStreamEnabled" [vbUiRadioBtn]="false" [notThemed]="!themed" [activeClass]="themed ? '' : 'active'" (ngModelChange)="onBackupStreamChange(rtmpContext.backupStreamEnabled, rtmpContext.isSecure)">
										{{ 'UI_Disabled' | translate }}
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			}
			@if (rtmpContext.backupStreamEnabled) {
				<div class="form-group row">
					<label class="control-label col-sm-3">{{ 'Event_Webcast_Rtmp_PushUrl_Backup' | translate }}
						<vb-ui-tooltip [iconName]="'circle_question_mark'" [placement]="'right'" [text]="'Event_Webcast_Rtmp_Url_Info' | translate">
						</vb-ui-tooltip>
					</label>
					<div class="col-sm-9">
						<div class="row">
							<div class="col-md-6 col-sm-9">
								{{ rtmpContext.backupStreamUrl }}
								<button type="button" class="margin-left-10" [attr.aria-label]="'Event_Webcast_Rtmp_PushUrlCopy_Backup' | translate" [title]="'Event_Webcast_Rtmp_PushUrlCopy_Backup' | translate" ngxClipboard [cbContent]="rtmpContext.backupStreamUrl" vbBtnWhite>
									<span class="glyphicons file_import"></span>
								</button>
							</div>
							<div *ngIf="errors?.SecondaryRtmpListenerUrlConflict" class="margin-left-16 col-md-6 col-sm-9 px-0" role="alert" vbUiErrorMessage>
							{{ 'Event_Webcast_Rtmp_PushUrlConflictError' | translate }}
						</div>
						</div>
					</div>
				</div>
				@if (webcastType !== WebcastVideoSource.SRT) {
					<div class="form-group row">
						<label class="control-label col-sm-3">{{ 'StreamKey_Backup' | translate }}</label>
						<div class="col-sm-9">
							<div class="row">
								<div class="col-md-6 col-sm-9">
									{{ rtmpContext.backupStreamKey }}
									<button type="button" class="margin-left-10" [attr.aria-label]="'Event_Webcast_Rtmp_StreamCopy_Backup' | translate" [title]="'Event_Webcast_Rtmp_StreamCopy_Backup' | translate" ngxClipboard [cbContent]="rtmpContext.backupStreamKey" vbBtnWhite>
										<span class="glyphicons file_import"></span>
									</button>
								</div>
							</div>
						</div>
					</div>
				}
				<div class="form-group row">
					<label class="control-label col-sm-3"></label>
					<div class="col-sm-9">
						<div class="row">
							<div class="col-sm-9 col-md-6">
								<button type="button" (click)="generateNewSettings(rtmpContext.isSecure)" vbBtnWhite>
									@if (webcastType !== WebcastVideoSource.SRT) {
										{{ 'Event_Webcast_Rtmp_RegenerateUrlAndKey_Backup' | translate }}
									}
									@else {
										{{ 'Event_Webcast_Srt_RegenerateUrl_Backup' | translate }}
									}									
								</button>
							</div>
						</div>
					</div>
				</div>
			}
		</ng-container>
	</ng-container>
</section>
